/**
 * The page builder's canvas address, in a module of its own because the guest
 * bundle's boot path reads it on every page load: `./preview.ts` is the whole
 * protocol, and a static import of it from `apps/site`'s `main.tsx` would put
 * every parser on the home page. The protocol is in `./preview.ts`.
 */
/**
 * **The canvas's address: `/#/__preview` on the tenant's own hostname.**
 *
 * A fragment, for the reason the owner's intake is one (`#/intake/<code>`):
 * the server never sees it. The load balancer sends `/` to the bucket (or,
 * after the flip, to `guest-api`'s page renderer) exactly as it does for any
 * visit, so neither can mistake the preview for a page — there is no
 * `/__preview` object to 404 on and no server route to mount — and no crawler
 * can ever be handed it as a separate address. The bundle reads the fragment
 * before it boots and becomes the canvas instead of the site.
 */
export const PREVIEW_HASH = '#/__preview';
/** Is this `location.hash` the canvas? Cheap enough for the boot path. */
export function isPreviewHash(hash) {
    return hash === PREVIEW_HASH || hash.startsWith(`${PREVIEW_HASH}?`);
}
//# sourceMappingURL=preview-address.js.map